<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import { comMapping } from '@/components/util/Function/comMapping';
import { 
		fangwxxpage, 
		fangwxxsave, 
		fangwxxupdate, 
		fangwxxdelete, 
		tudztxxdelete ,
		queryByCompanyFcTdShenb,
		startTaxGather
	} from '../../../../../../../api/cztds.js';
import axios from 'axios';
export default {
	name: '',
	components: {},
	props: {
		invoicediag: {
			type: Boolean,
			default: false
		},
		mxsearch: {
			type: Object,
			default: {}
		},
		paramsx: {
			type: Object,
			default: {}
		},
		shoudata: {
			type: Number,
			default: 0
		},
		outlistx: {
			type: Object,
			default: {}
		}
	},
	watch: {
		shoudata: function(indexVal, oldVal) {
			if (indexVal > 1) {
				// this.invoicediag = false;
				this.page();
				this.title = '新增登记';
				this.Period();
			} else if (indexVal == 1) {
				this.Period();
				// this.copyinvoice = false;
				this.title = '修改登记';
			}
		}
	},
	data: function() {
		return {
			maplist:[
					{
						value:null,
						item:'未采集'
					},
					{
						value:1,
						item:'未采集'
					},
					{
						value:2,
						item:'采集成功'
					},
					{
						value:3,
						item:'采集失败'
					},
					{
						value:4,
						item:'采集中'
					}
				],
			select_error: false,
			czjz: comMapping.$czfwlist,
			title: '新增登记',
			copyinvoice: false,
			headData: getdata().headData,
			pagination: getdata().pagination,
			tableData: [{}],
			radio: {},
			lebal: '',
			dropDown: [],
			copyinvoices: false,
			formlist: getdata().formlist,
			formdata: getdata().formdata,
			options: [],
			value: '',
			index: []
		};
	},
	mounted() {
		this.uetiu();
	},
	methods: {
		Shui(e){
				this.$showConfirm({
				 		  message: "是否上传税源至税局?",
						  title:"标题",
				 		}).then((res) => {
				 		  if (res == "confirm") {
							 let params = {
							 	type:'5',
							 	detailIds:e.id
							 }
							 startTaxGather(params).then(res=>{
							 	if(res.data.code == 1 ){
							 		this.page();
							 	}else{
							 		this.$message.error(res.data.msg)
							 	}
							 })
				 		  }
				 		});
		},
		Period() {
			this.dropDown = [];
			let params = {
				companyNo: this.outlistx.companyNo,
				suosq: this.outlistx.suosq,
				type: 'ccxwfccz'
			};
			queryByCompanyFcTdShenb(params).then(res => {
				if (res.data.code == 1) {
					res.data.data.map(item => {
						this.dropDown.push({
							value: item.suossqz,
							label: item.suossqz
						});
					});
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		uetiu() {
			let UrbanData = window.$UrbanData_mb || window.$UrbanData;
			keyt(UrbanData);
			function keyt(data) {
				data.map(item => {
					item.value = item.label;
					if (item.children) {
						keyt(item.children);
					}
				});
			}
			let data = JSON.parse(JSON.stringify(UrbanData));
			this.options = data.map(item => {
				item.children.map(item1 => {
					item1.children.map(item2 => {
						delete item2.children;
					});
				});
				return item;
			});
		},
		shuiebz(e) {
			console.log('更新打印')
			this.paramsx.yingnse = this.paramsx.shenbzjsr * 0.12;
			let amount = 0;
			this.paramsx.jianms.forEach((item, index) => {
				if (item.jianmje != '' && item.jianmqsyf != '' && item.jianmqsyf != null && item.jianmzzyf != '' && item.jianmzzyf != null) {
					let times = 1;
					let start = item.jianmqsyf.substring(4, 6);
					let stop = item.jianmzzyf.substring(4, 6);
					if (start <= stop) {
						times = stop - start == 0 ? 1 : stop - start + 1;
					} else {
						let centre = item.jianmqsyf;
						item.jianmqsyf = item.jianmzzyf;
						item.jianmzzyf = centre;
						start = item.jianmqsyf.substring(4, 6);
						stop = item.jianmzzyf.substring(4, 6);
						times = stop - start + 1;
					}
					amount += Number(item.jianmje) * times;
				}
			});
			if (this.outlistx.lflszc == 'Y') {
				this.paramsx.liuslfjmse = (Number(this.paramsx.yingnse) - amount) / 2;
			}
			this.paramsx.benqybtse = Number(this.paramsx.yingnse) - Number(this.paramsx.liuslfjmse) - Number(this.paramsx.benqyjse) - amount;
		},
		nextxx() {
			if (this.formdata.tudzldzShi == '') {
				this.select_error = true;
				this.$refs.taxform.submitForm();
			} else {
				this.$refs.taxform.submitForm();
			}
		},
		alone() {
			if (this.formdata.tudzldzShi == '') {
				this.select_error = true;
			}
		},
		oucz() {
			this.page();
		},
		remove() {
			if (this.value2 == 2) {
				this.$showConfirm({
					message: '确认删除?'
				}).then(res => {
					if (res == 'confirm') {
						let params = { id: this.formdata.id };
						fangwxxdelete(params).then(res => {
							if (res.data.code == 1) {
								this.copyinvoices = false;
								this.page();
							} else {
								this.$message.error(res.data.msg);
					 	}
						});
					}
				});
			} else {
				this.copyinvoices = false;
			}
		},
		xq(e) {
			this.formlist=getdata().formlist
			this.formdata = JSON.parse(JSON.stringify(e));
			this.formdata.fangwzldzShi = [e.fangwzldzSheng, e.fangwzldzShi, e.fangwzldzXian];
			
			this.copyinvoices = true;
			this.value2 = 2;
			this.info();
		},
		getdatasave() {
			let outx = this.formdata;
			outx.nsrsbh = this.outlistx.nsrsbh;
			outx.fangwzldzSheng = outx.fangwzldzShi[0];
			outx.fangwzldzXian = outx.fangwzldzShi[2];
			outx.fangwzldzShi = outx.fangwzldzShi[1];
			let params = outx;
			if (this.value2 == 2) {
				fangwxxupdate(params).then(res => {
					if (res.data.code == 1) {
						this.copyinvoices = false;
						this.page();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			} else {
				fangwxxsave(params).then(res => {
					if (res.data.code == 1) {
						this.copyinvoices = false;
						this.page();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			}
		},
		xzzt() {
			this.formlist=getdata().formlist
			const index = this.formlist.findIndex(item => item.prop === 'bgsj');
			if (index !== -1) {
				this.formlist.splice(index, 1);
			}
			this.uetiu();
			this.select_error = false;
			this.info();
			this.formdata = getdata().formdata
			Object.keys(this.formdata).map(key => {
				if (key == 'dailrysfzlx') {
					this.formdata[key] = '201';
				} else if(key == 'nsywYxqz'){
				this.formdata[key] = '2099-12-31';
				}else{
					this.formdata[key] = '';
				}
			});
			this.formdata = JSON.parse(JSON.stringify(this.formdata))
			this.value2 = 1;
			this.copyinvoices = true;
			this.$refs.taxform.clearValidate();
		},
		info() {
			this.formlist.map(item => {
				if (item.prop == 'nsrlx') {
					item.selectval = [];
					this.mxsearch.cjjzNsrxz.map(item1 => {
						item.selectval.push(item1);
					});
				} else if (item.prop == 'fangcyt') {
					item.selectval = [];
					this.mxsearch.cjjzFcyt.map(item1 => {
						item.selectval.push(item1);
					});
				}else if (item.prop == 'cqzhlx') {
					item.selectval = [];
					this.mxsearch.fcsCqzhlb.map(item1 => {
						item.selectval.push(item1);
					});
				}
			});
		},
		outset(e) {
			this.formdata.fangwzldzXiangz = '';
			// this.formlist[14].selectval =  this.$ctx({level:4,name:e[2]})
			this.select_error = false;
			let index = 0;
			let UrbanData = window.$UrbanData_mb || window.$UrbanData;
			this.Urban(UrbanData, e, index);
			this.formlist[15].selectval = this.index;
		},
		Urban(list, e, index) {
			list.map(item => {
				if (item.value == e[index]) {
					if (index < 2) {
						index++;
						this.Urban(item.children, e, index);
					} else {
						this.index = item.children;
					}
				}
			});
		},
		nextxuan() {
			Object.keys(this.radio).map(key => {
				this.paramsx[key] = this.radio[key];
			});
			this.copyinvoice = false;
			this.radio = {};
		},
		page() {
			let params = {
				nsrsbh: this.outlistx.nsrsbh,
				size: this.pagination.pageSize,
				current: this.pagination.pageNum
			};
			fangwxxpage(params).then(res => {
				if (res.data.code == 1) {
					this.tableData = res.data.data.records;
					this.pagination.total = res.data.data.total;
					this.invoicediag = true;
					this.copyinvoice = true;
					this.$nextTick(()=>{
					this.$refs.tableboxFw.dout()
					})
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		nextxz() {
			if (this.paramsx.fangcbh == '' || this.paramsx.shenbzjsr == '' || this.paramsx.chuzfcmj == '' || this.paramsx.zulqq == '' || this.paramsx.zulqz == ''|| !this.paramsx.suosqqz||this.paramsx.suosqqz=='') {
				if (this.paramsx.fangcbh == '') {
					return this.$message.error('请选择您需要的住房信息');
				} else {
					return this.$message.error('请补充完整必填部分');
				}
			}
			this.$emit('nextxz', this.paramsx);
		},
		sizechange(e) {},
		currentChange(e) {},
		closediag() {
			this.$emit('closediag', false);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
